"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useGoogleMaps;
exports.statuses = void 0;
var _react = require("react");
var _loadGoogleMaps = _interopRequireDefault(require("./loadGoogleMaps"));
const statuses = exports.statuses = {
  PENDING: 'pending',
  LOADED: 'loaded',
  ERROR: 'error'
};

/**
 * hook to use google maps
 * @param {String} url
 * @return {{status: Status, gMaps: google.Maps}}
 */
function useGoogleMaps(url) {
  const [status, setStatus] = (0, _react.useState)(statuses.PENDING);
  const gMapsRef = (0, _react.useRef)();
  const didLoad = (0, _react.useRef)(false);
  (0, _react.useEffect)(() => {
    if (didLoad.current) {
      return;
    }
    (0, _loadGoogleMaps.default)(url).then(res => {
      gMapsRef.current = res;
      setStatus(statuses.LOADED);
    }).catch(() => {
      setStatus(statuses.ERROR);
    });
    didLoad.current = true;
  });
  return {
    status,
    gMaps: gMapsRef.current
  };
}